// src/components/error-boundary/ErrorFallback.tsx
import { useCallback } from 'react';
import { useTranslations } from '@/hooks/useTranslations';
import { Button } from '@/components/ui/button';
import { RefreshCcw, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ErrorFallbackProps {
  error: Error | null;
  onReset: () => void;
}

const ErrorFallback = ({ error, onReset }: ErrorFallbackProps) => {
  const { content } = useTranslations();
  const navigate = useNavigate();

  const handleHomeClick = useCallback(() => {
    onReset();
    navigate('/');
  }, [navigate, onReset]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground">
            {content.errors.title}
          </h1>
          <p className="text-muted-foreground">
            {content.errors.description}
          </p>
          {error && (
            <pre className="mt-4 p-4 bg-muted rounded-lg text-sm text-left overflow-auto">
              {error.message}
            </pre>
          )}
        </div>

        <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
          <Button 
            onClick={onReset}
            className="gap-2"
          >
            <RefreshCcw className="h-4 w-4" />
            {content.errors.tryAgain}
          </Button>
          <Button 
            variant="outline" 
            onClick={handleHomeClick}
            className="gap-2"
          >
            <Home className="h-4 w-4" />
            {content.errors.backHome}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;